<template>
    <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
            <v-btn class="mb-3" block dark color="cyan" v-on="on">공지 추가하기</v-btn>
        </template>
        <v-card flat max-width="500" class="mx-auto">
            <v-card-title color="blue-grey accent-4" class="mb-3">공지 추가하기</v-card-title>
            <v-card-text>
                <v-form v-model="valid" ref="form">
                    <v-select
                        :items="items"
                        v-model="item"
                        label="분류"
                        prepend-icon="mdi-group"
                        required>
                    </v-select>
                    <v-text-field
                        v-model="title"
                        label="제목"
                        :rules="titleRules"
                        hint="ex) 회원 조건"
                        prepend-icon="mdi-format-title"
                        required>
                    </v-text-field>
                    <v-text-field
                        v-model="content"
                        label="내용"
                        :rules="contentRules"
                        hint="ex) 은샘교회 출석인 및 VIP"
                        prepend-icon="mdi-card-text-outline"
                        required>
                    </v-text-field>
                    <v-select
                        :items="icons"
                        v-model="iconName"
                        label="아이콘"
                        prepend-icon="mdi-emoticon-poop-outline"
                        required>
                    </v-select>                    
                    <p class="text-center caption pink--text" v-if="feedback">{{ feedback }}</p>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            :loading="loading"
                            class="mt-5 white--text"
                            color="blue-grey accent-4"
                            @click="creatingNotice"
                            :disabled="!valid"
                        >보내기</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
    
</template>
<script>
import db from '@/fb'
// import firebase from 'firebase/app'
// import 'firebase/auth'

export default {
    props: [ 'user', 'groupId', 'notices' ],
    data: () => ({
        dialog: false,
        loading: false,
        valid: false,
        title: null,
        content: null,
        feedback: null,
        titleRules: [
            v => !!v || '제목은 꼭 필요해요!'
        ],
        contentRules: [
            v => !!v || '내용은 꼭 필요해요!'
        ],
        items: ['모임소개', '연락처', '기타'],
        item: null,
        icons: [ '사람', '회비', '달력', '레슨', '전화', '장소', '기타'],
        iconPairs: [
            { name: "사람", icon: "mdi-account-multiple"},
            { name: "회비", icon: "mdi-bank"},
            { name: "달력", icon: "mdi-calendar-clock"},
            { name: "레슨", icon: "mdi-teach"},
            { name: "전화", icon: "mdi-phone"},
            { name: "장소", icon: "mdi-map-marker-outline"},
            { name: "기타", icon: "mdi-ufo-outline"}
        ],
        iconName: null
    }),
    methods: {
       creatingNotice(){
           let icon = null;
           this.iconPairs.forEach(pair => {
               if(pair.name == this.iconName){
                   icon = pair.icon
               }
           })
           let content = {
               header: this.item,
               title: this.title,
               content: this.content,
               icon: icon,
               timeStamp: Date.now()
           }
           
           db.collection(this.groupId + '-notices').add(content).then(() => {
                this.dialog = false;
                this.loading = false;
           })
       }
    }
}
</script>

<style>

</style>